//@flow
import React from 'react';
import MenuCard from 'components/molecules/menuCard';
import HamburgerMenu from 'components/organisms/hamburgerMenu';
import type { SiteSettings, Vertical } from 'types/common';
import { filter } from 'lodash';

type Props = {
  verticals: Array<Vertical>,
  siteSettings: SiteSettings,
  theme: string,
  onClosePress: () => void,
  fullPageApi: () => void,
};

export const MainMenuMobile = (props: Props) => {
  const { verticals, siteSettings, theme, onClosePress, fullPageApi } = props;
  let sortedVerticals = filter(verticals, function(n) {
    return n.id !== 11;
  });
  return (
    <>
      <div className={'mobile-gutter menu-cards'}>
        {sortedVerticals.map(item => (
          <MenuCard data={item} onPress={onClosePress} key={item.id} />
        ))}
      </div>
      <div className={'sidebar'}>
        <HamburgerMenu
          theme={theme}
          data={siteSettings}
          onPress={onClosePress}
          fullPageApi={fullPageApi}
        />
      </div>
    </>
  );
};
